import request from "../composables/useHttp";

/**
 * @description: 获取党群建设列表
 * */
export function getAListOfPartyAndMassBuilding(params) {
    return request("/partyBuilding/gw/findPartyBuildings", {
        method: 'get',
        params
    })
}


/**
 * @description: 获取党群建设详情
 * */
export function getDetailsOnPartyAndMassBuilding(params) {
    return request("/partyBuilding/gw/findPartyBuildingDetailById", {
        method: 'get',
        params
    })
}


/**
 * @description: 获取党群建设详情推荐详情
 * */
export function getGWRecommendedPartyBuilding(params) {
    return request("/partyBuilding/gw/findGWRecommendedPartyBuildingByPartyBuildingId", {
        method: 'get',
        params
    })
}

//